import { Globe } from 'lucide-react';

/**
 * The hostname names no portal: the resolve endpoint answered 404 ("There is
 * no active portal at this address"). Shown in place of the whole app. The
 * neutral login page used to render here, and it could never sign anyone
 * in — the platform's bare apex, a mistyped subdomain, a custom domain not
 * yet verified all looked like a working portal that refused every password.
 *
 * Names no vendor and no MSP: on the bare apex nobody has said whose portal
 * this is. The example address is built from the hostname only when it is
 * an apex (two labels), where "yourcompany.<apex>" is the shape every
 * tenant address takes.
 */
export default function NoPortalHere() {
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  const example = host && host.split('.').length === 2 ? `yourcompany.${host}` : null;
  return (
    <div className="flex min-h-screen items-center justify-center bg-neutral-50 p-6 dark:bg-neutral-900">
      <div className="max-w-md text-center">
        <Globe className="mx-auto mb-4 h-10 w-10 text-neutral-400" />
        <h1 className="mb-2 text-2xl font-bold text-neutral-900 dark:text-white">No portal at this address</h1>
        <p className="mb-3 text-neutral-600 dark:text-neutral-300">
          Each customer portal has its own address. Check the one your IT provider gave you
          {example ? <> — it looks like <code className="rounded bg-neutral-100 px-1.5 py-0.5 text-sm dark:bg-neutral-800">{example}</code></> : null}.
        </p>
        <p className="text-sm text-neutral-500 dark:text-neutral-400">
          If you run this portal and expected it here, the address has not been set up yet.
        </p>
      </div>
    </div>
  );
}
